import React from 'react';

const removeDangerousNodes = (rootNode) => {
    const blockedSelectors = ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta'];

    blockedSelectors.forEach((selector) => {
        rootNode.querySelectorAll(selector).forEach((node) => node.remove());
    });

    rootNode.querySelectorAll('*').forEach((node) => {
        Array.from(node.attributes).forEach((attribute) => {
            const attributeName = attribute.name.toLowerCase();
            const attributeValue = String(attribute.value || '').trim().toLowerCase();

            if (attributeName.startsWith('on')) {
                node.removeAttribute(attribute.name);
                return;
            }

            if ((attributeName === 'href' || attributeName === 'src') && attributeValue.startsWith('javascript:')) {
                node.removeAttribute(attribute.name);
            }
        });
    });
};

const sanitizeHTML = (html) => {
    if (!html) {
        return '';
    }

    if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
        return html;
    }

    const parser = new window.DOMParser();
    const documentNode = parser.parseFromString(html, 'text/html');

    removeDangerousNodes(documentNode.body);

    return documentNode.body.innerHTML;
};

export const SafeHTML = ({ html = '', className = '' }) => (
    <div
        className={`rich-text-content ck-content ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(html) }}
    />
);
